import React, { useEffect, useState } from 'react'
import {
  Button,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Input, Label, Form, FormGroup
} from 'reactstrap'
import _ from 'lodash'

import MultilingualInput from 'components/MultiLangInput/v2'
import Lang from 'Lang/General'

function IndustryForm({
  data,
  mode,
  onSubmit,
  onClose,
  selectedIndustries,
  clientID
}) {
  const [formData, setFormData] = useState({
    title: {
      en: '',
      de: '',
      it: '',
      nl: ''
    },
    status: 'ACTIVE',
    client_id: clientID
  })

  useEffect(() => {
    if (mode === 'edit' && selectedIndustries) {
      setFormData({
        ...selectedIndustries,
        status: selectedIndustries.is_active ? 'ACTIVE' : "INACTIVE"
      })
    }
  }, [selectedIndustries])

  const onChangeField = (key, val) => setFormData({
    ...formData,
    [key]: val
  })

  return (
    <>
      <ModalHeader toggle={() => onClose()} >
        {Lang[mode === 'create' ? 'CREATE_INDUSTRY' : 'UPDATE_INDUSTRY'][data.languageReducer.userSettings.admin_panel_language]}</ModalHeader>
      <ModalBody>
        <Form>
          <MultilingualInput
            label={ Lang[ 'TITLE' ][ data.languageReducer.userSettings.admin_panel_language ] }
            selectedLanguage={ data.languageReducer.userSettings.admin_panel_language }
            value={ formData.title }
            parent={ formData.title }
            onChangeValue={ ( parentName, formDataValue ) => onChangeField ('title', formDataValue ) }
          />
          <FormGroup>
            <Label>
              {Lang['STATUS'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={formData.status}
              type={'select'}
              onChange={e => onChangeField('status', e.target.value)}
            >
              <option value="ACTIVE">
                {Lang['ACTIVE'][data.languageReducer.userSettings.admin_panel_language]}
              </option>
              <option value="INACTIVE">
                {Lang['INACTIVE'][data.languageReducer.userSettings.admin_panel_language]}
              </option>
            </Input>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={() => {
            onSubmit({
              ...formData,
              is_active: formData.status === 'ACTIVE'
            })
          }}>
          {Lang['SUBMIT'][data.languageReducer.userSettings.admin_panel_language]}</Button>
      </ModalFooter>
    </>
  )
}

export default IndustryForm